import { configureStore } from "@reduxjs/toolkit";

//reducers below
import userReducer from "./slices/userSlice";
import uiReducer from "./slices/uiSlice";
import langReducer from "./slices/langSlice";
import doctorSlice from "./slices/doctorSlice";
//reducers above

export default configureStore({
    reducer:{
        user: userReducer,
        ui: uiReducer,
        lang: langReducer,
        doctor_data: doctorSlice
    } 
})
